import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'


const SingleOrderButtons = ({ order, user }) => {



    return (
        <Fragment>
            <div className="flex items-center gap-2 px-[0.5vmax] flex-[1] justify-center">
                <Link
                    to={`/orders/order-details?order_id=${order?.id}`}
                    className="px-4 py-1.5 bg-gradient-to-r from-blue-500 to-blue-600 rounded-lg text-white text-[1.2vmax] lg:text-[0.8vmax] font-jakarta font-semibold hover:shadow-md transition-all active:scale-[0.98] capitalize"
                >
                    view
                </Link>
            </div>
        </Fragment>
    )
}

export default SingleOrderButtons